import { useI18n } from '../../../i18n';
// ============================================
// CategoryFilterBar Component
// ============================================

interface CategoryFilterBarProps {
  searchQuery: string;
  statusFilter: string;
  onSearchChange: (v: string) => void;
  onStatusFilterChange: (v: string) => void;
}

export function CategoryFilterBar({
  searchQuery, statusFilter, onSearchChange, onStatusFilterChange,
}: CategoryFilterBarProps) {
  const { t } = useI18n();
  return (
    <div className="flex flex-col gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm sm:flex-row sm:items-center sm:justify-between sm:gap-4">
      <div className="relative w-full sm:w-72">
        <svg
          className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
          width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" strokeWidth="2"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t('searchCategories')}
          enterKeyHint="search"
          onKeyDown={(e) => { if (e.key === 'Enter') e.currentTarget.blur(); }}
          className="h-9 w-full rounded-lg border border-slate-200 bg-white pl-9 pr-3 text-sm focus:border-blue-400 focus:outline-none"
        />
      </div>
      <select
        value={statusFilter}
        onChange={(e) => onStatusFilterChange(e.target.value)}
        className="h-9 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-700 focus:border-blue-400 focus:outline-none"
      >
        <option value="">{t('allStatus')}</option>
        <option value="active">{t('categoriesActive')}</option>
        <option value="inactive">{t('categoriesInactive')}</option>
      </select>
    </div>
  );
}
